import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=676c553d&scoped=true&"
import script from "./customerDetails.vue?vue&type=script&lang=js&"
export * from "./customerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676c553d",
  null
  
)

export default component.exports